import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as screen2 from "./style.module.scss";
import { TaxDeduction } from "../../../../TaxDeduction";
import { Modal } from '../../../../Modal';
import {AccessLimited} from "../../../../AccessLimited";
export const Screen2 = ({ btnText, widget, free=false, accessLimited }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={screen2.screen2}>
      <div className="container"><i className={screen2.ico}></i>
        <div className={screen2.fb}>
          <div className={screen2.desc}>Тренинг оказался очень полезным, узнал о эффективной методике запоминания, получил заряд мотивации, узнал о полезности пальцевой гимнастики.</div>
          <div className={screen2.name}>Покровский Александр</div>
        </div>
        <div className={screen2.fb}>
          <div className={screen2.desc}>Замечательный педагог с легкой и интересной подачей материала. Очень ценно чувство юмора. <br/> Благодарю!</div>
          <div className={screen2.name}>Ионова Ирина</div>
        </div>
        <div className={screen2.fb}>
          <div className={screen2.desc}>Благодарю! Очень полезно, быстро доходчиво и живо!</div>
          <div className={screen2.name}>Александров Владимир</div>
        </div>
        <div className={main.btnBlock}>
          <button className={`btn ${main.mainBtn}`} onClick={()=>{setShowModal(true)}}>
            {
              btnText || `Купить за 990\u00A0₽`
            }

          </button>
        </div>
        {
          !free && <TaxDeduction margin={"30px 0 50px"} align={"center"} font={"18px"}/>
        }
        {
          accessLimited && <AccessLimited margin={"30px 0 50px"} align={"center"} font={"18px"}/>
        }
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
